<template>
  <transition v-bind="transitionProps">
    <div v-show="isSelected()">
      <div v-if="isSambaServiceAccount()">
        <div :class="$style.item">
          <i :class="['jc-ldap-circle', 'ldap-brand', $style.icon]" />
          <span :class="$style.text">LDAP Bind DN</span>
        </div>
        <div :class="$style.item">
          <i :class="['jc-samba-circle', 'samba-brand', $style.icon]" />
          <span :class="$style.text">Samba Service Account</span>
        </div>
      </div>
      <div v-else>
        <CustomSelectIconList
          :menuItems="menuItems"
          :selectedValueIconClassName="bindStatusIconClassName"
          :selectedValueText="bindStatusText"
        />
      </div>
    </div>
  </transition>
</template>
<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import CustomSelectIconList from 'client/components/ItemTable/BodyComponents/CustomSelectIconList.vue';

const storeModule = StoreModuleMap[ItemTypeConsts.systemUser];

export default {
  name: 'BindStatus',

  components: {
    CustomSelectIconList,
  },

  props: {
    item: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      menuItems: [
        {
          onClick: () => this.handleBindStatusChanged(true),
          iconClassName: ['jc-ldap-circle', 'ldap-brand'],
          text: 'LDAP Bind DN',
        },
        {
          onClick: () => this.handleBindStatusChanged(false),
          iconClassName: 'jc-none',
          text: 'None',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(storeModule, {
      isLdapBindingUser: 'isLdapBindingUser',
      selectedItems: 'getSelectedItems',
    }),

    bindStatusIconClassName() {
      const { id } = this.item;
      return this.isLdapBindingUser(id) ? ['jc-ldap-circle', 'ldap-brand'] : 'jc-none';
    },

    bindStatusText() {
      const { id } = this.item;
      return this.isLdapBindingUser(id) ? 'LDAP Bind DN' : 'None';
    },

    transitionProps() {
      return {
        enterClass: this.$style.containerEnter,
        enterActiveClass: this.$style.containerTransition,
        leaveActiveClass: this.$style.containerTransition,
        leaveToClass: this.$style.containerLeaveTo,
      };
    },
  },

  methods: {
    ...mapActions(storeModule, [
      'updateLdapBindingUser',
    ]),

    handleBindStatusChanged(value) {
      const { id } = this.item;
      this.updateLdapBindingUser({ id, ldapBindingUser: value });
    },

    isSambaServiceAccount() {
      return this.item && this.item.samba_service_user === true;
    },

    isSelected() {
      return this.selectedItems.indexOf(this.item.id) !== -1;
    },
  },
};
</script>
<style module>
@value (panelSpeed, panelTimingFunction) from '~css/transitions.css';

/*
 * TODO: The containerEnter, containerLeaveTo, and containerTransition styles
 * are copied from SudoStatus.vue and will be moved to a common location so
 * they can be reused in both components.
 */
.containerEnter,
.containerLeaveTo {
  opacity: 0;
}

.containerTransition {
  transition: opacity panelSpeed panelTimingFunction;
}

/*
 * TODO: These styles are duplicated from the DirectoryAccessConfiguration
 * component. Can they be moved to a common location and shared by both
 * components?
 */
.item {
  line-height: 16px;
  margin-bottom: 3px;
}

.icon {
  display: inline-block;
  font-size: 16px;
  margin-right: 8px;
  vertical-align: middle;
}

.text {
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  vertical-align: middle;
}
</style>
